export default {
  nameImage: (state) => state.nameImage,
}
